export default "__VITE_ASSET__a8046393__"